import { Outlet, useParams } from "react-router-dom";
import { PageContent, PageSection } from "../styles/Home.styled";
import { Header } from "../components/Header";
import { Sidebar } from "../components/Sidebar";
import { useEffect, useState } from "react";
import { fetchProviderData } from "../api/fetch";
import { ProviderType } from "./chat";
import { RootContext } from "../context/RootContext";
import { findProviderByName, mergeProviderData } from "../util/util";
import { providerDescriptions } from "../provider_descriptions";

export const Home = () => {
  const { provider } = useParams();
  const [providerData, setProviderData] = useState<ProviderType | undefined>(
    undefined
  );

  useEffect(() => {
    if (provider) {
      fetchProviderData("").then((res) => {
        if (res && res.status === "1") {
          const txProviders = res?.response?.["TX"] || [];

          const formattedList = mergeProviderData(
            txProviders,
            providerDescriptions
          );

          const result = findProviderByName(formattedList, provider);

          if (result) setProviderData(result);
        }
      });
    }
  }, [provider]);

  return (
    <RootContext.Provider value={{ providerData }}>
      <PageSection>
        <Header />
        <Sidebar />
        <PageContent>
          <Outlet />
        </PageContent>
      </PageSection>
    </RootContext.Provider>
  );
};
